import { MainPicture } from '@/promotions/promotions/promotions.component';
import { ProductKind, Tag } from '@/reservation/reservation.model';

export enum SectionMarks {
	HIGHLITED = 'B',
	BASIC = 'N',
	LIST = 'L',
	HORIZONTAL = 'H',
}

export interface Product {
	id: number;
	productKind: ProductKind;
	name: string;
	status: string;
	code: string;
	location: Location[];
	tags: Tag[];
	mainPicture: MainPicture;
	nightsStay: number;
	isNightEvent: boolean;
}
